import { Link } from 'react-router-dom';
import { useState, FormEvent } from 'react';
import { siteInfo } from '@/mocks/comics';

const footerLinks1 = [
  { path: '/category/romance', label: '恋爱漫' },
  { path: '/category/fantasy', label: '奇幻漫' },
  { path: '/category/action', label: '热血漫' },
  { path: '/category/drama', label: '剧情漫' },
  { path: '/category/thriller', label: '悬疑漫' },
];

const footerLinks2 = [
  { path: '/category/comedy', label: '搞笑漫' },
  { path: '/category/school', label: '校园漫' },
  { path: '/category/historical', label: '古风漫' },
  { path: '/about', label: '关于我们' },
];

export default function Footer() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('submitting');
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('contact_alt') as string)?.trim();

    if (honeypot) {
      setFormStatus('success');
      form.reset();
      return;
    }

    formData.delete('contact_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d96f8cdtfb6ioa7s1nmg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        responseText;

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else if (serverMsg.toLowerCase().includes('spam') || serverMsg.toLowerCase().includes('form data is spam')) {
        setFormError('提交失败，请稍后再试');
        setFormStatus('error');
      } else {
        setFormError(serverMsg || '提交失败，请稍后再试');
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto">
          <div>
            <h3 className="font-heading text-2xl font-bold text-background-50 mb-6">
              爱漫画
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed">
              {siteInfo.slogan}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">
              热门分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks1.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">
              更多分类
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks2.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">
              订阅更新
            </h4>
            <p className="text-sm text-foreground-300 mb-4">
              第一时间获取最新韩漫上架通知
            </p>
            <form
              id="newsletter-form"
              data-readdy-form="newsletter"
              onSubmit={handleSubmit}
              className="relative"
            >
              <div className="form-contact-alt">
                <input
                  type="text"
                  name="contact_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>
              <div className="flex">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入您的邮箱"
                  className="flex-1 px-4 py-2.5 rounded-l-full bg-foreground-800 text-background-50 text-sm placeholder-foreground-400 outline-none border-0"
                />
                <button
                  type="submit"
                  disabled={formStatus === 'submitting'}
                  className="w-11 h-11 flex items-center justify-center rounded-r-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer disabled:opacity-60"
                  aria-label="订阅"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              {formStatus === 'success' && (
                <p className="mt-2 text-xs text-accent-400">订阅成功！感谢您的关注。</p>
              )}
              {formStatus === 'error' && (
                <p className="mt-2 text-xs text-primary-400">{formError}</p>
              )}
            </form>
          </div>
        </div>
      </div>

      <div className="relative border-t border-foreground-800/50">
        <div className="px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 max-w-7xl mx-auto">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} 爱漫画 Aimanga.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="邮箱">
              <i className="ri-mail-line text-lg"></i>
            </a>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 overflow-hidden pointer-events-none select-none">
          <span className="block text-[120px] md:text-[180px] font-heading font-black text-foreground-800/20 leading-none whitespace-nowrap">
            爱漫画
          </span>
        </div>
      </div>
    </footer>
  );
}